export default __webpack_public_path__ + "static/media/toys.f92f8e1c.jpg";